<template>
  <div>
    <v-toolbar
      dark
      :style="{ background: getThemeColor, color: 'white' }"
      shaped
    >
      <v-autocomplete
        prepend-inner-icon="search"
        v-model="selectedRateID"
        :items="rates"
        class="ml-4"
        flat
        hide-no-data
        hide-details
        :label="'Select Service Rate To Apply'"
        solo-inverted
        @change="getSelectedRate()"
      ></v-autocomplete>
      <v-btn icon @click="openGlobalDialogSlot()">
        <v-icon small>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>

    <v-autocomplete
      v-if="getUserCompany.industry == 'Agency'"
      prepend-inner-icon="search"
      v-model="selectedAgencyFee"
      :items="agencyFees"
      class="mt-4"
      flat
      hide-no-data
      hide-details
      :label="'Select Agency Fee To Apply'"
      solo-inverted
      @change="getSelectedAgencyFee()"
    ></v-autocomplete>

    <GlobalDialogSlot
      :title="title"
      :dialog="dialog"
      @close-dialog="dialog = false"
    >
      <CreateService
        @service-created="getNewRate"
        @exist="title = 'Item Exist'"
      ></CreateService>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import mainJs from "../main";
import GlobalDialogSlot from "./GlobalDialogSlot.vue";
import CreateService from "./CreateService.vue";

export default {
  components: { GlobalDialogSlot, CreateService },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getRetrieveAllRatesRoute() {
      return this.$store.getters.getRetrieveAllRatesRoute;
    },
    getAllAgencyFeesRoute() {
      return this.$store.getters.getAllAgencyFeesRoute;
    },
  },
  async mounted() {
    await this.getAllRates();
    await this.getAllAgencyFees();
  },
  data: () => ({
    dialog: false,
    title: "Create Service Rate",
    rates: [],
    agencyFees: [],
    selectedRateID: null,
    selectedAgencyFee: {
      percentage: 0,
      name: "",
    },
  }),
  methods: {
    async getAllAgencyFees() {
      const agencyFees = await mainJs.getAllAgencyFees(
        this.getApiUrl + this.getAllAgencyFeesRoute,
        this.getAccessToken
      );
      if (agencyFees.length > 0) {
        this.agencyFees = [];
        agencyFees.forEach((fee) => {
          this.agencyFees.push({
            text: `${fee.name} [${fee.percentage}%]`,
            value: fee,
          });
        });
      }
    },
    getSelectedAgencyFee() {
      if (
        this.selectedAgencyFee &&
        this.selectedAgencyFee.percentage.includes("%")
      ) {
        this.selectedAgencyFee.percentage =
          this.selectedAgencyFee.percentage.replace("%", "");
      }
      this.selectedAgencyFee.percentage = Number(
        this.selectedAgencyFee.percentage
      );
      if (this.selectedAgencyFee.percentage > 0) {
        this.selectedAgencyFee.percentage = (
          Number(this.selectedAgencyFee.percentage) / 100
        ).toFixed(2);
      } else {
        return 0;
      }
      this.$emit("agency-fee-selected", this.selectedAgencyFee);
    },
    async getAllRates() {
      this.$store.commit("setLoader", true);
      const rates = await mainJs.getAllRates(
        this.getApiUrl + this.getRetrieveAllRatesRoute,
        this.getAccessToken
      );

      this.rates = [];
      rates.forEach((rate) => {
        this.rates.push({
          text: rate.name + " | " + this.getCurrency + rate.price,
          value: `${rate.id}-${rate.price}`,
        });
      });

      this.$store.commit("setLoader", false);
    },
    getNewRate(rate) {
      this.rates.push({
        text: rate.name + " | " + this.getCurrency + rate.price,
        value: `${rate.id}-${rate.price}`,
      });
      this.$emit("rate-selected", rate.id);
      this.dialog = false;
    },
    getSelectedRate() {
      this.$emit("rate-selected", this.selectedRateID);
    },
    openGlobalDialogSlot() {
      this.dialog = true;
    },
  },
};
</script>

<style></style>
